import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCompare = (props) => /* @__PURE__ */ _jsx("svg", {
	focusable: "false",
	"aria-hidden": "true",
	viewBox: "0 0 24 24",
	"data-testid": "CompareIcon",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2zm0 15H5l5-6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2" })
});
export default SvgCompare;
